import React from 'react';
import cls from 'classnames';
import { Button } from 'reactstrap';
import './From.scss';

/**
 * @param {object} props
 * @param {boolean} disabled
 */

function CusButton({ className, children, disable, ...props }) {
  return (
    <Button
      className={cls(
        'CusButton',
        'p-1',
        'pl-3',
        'pr-3',
        className,
        props.disabled ? 'CusButton_disabled' : '',
      )}
      { ...props }
    >
      {props.icon ? (<i className={cls(props.icon)} />) : null}
      {children}
    </Button>
  );
}

CusButton.White = ({ ...props }) => {
  return <CusButton {...props} className={cls("CusButton_white", props.className)} />;
};
CusButton.Red = ({ ...props }) => {
  return <CusButton {...props} className={cls("CusButton_red", props.className)} />;
};

export { CusButton };
